import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Home from '../views/Home.vue'
import Mobile from '../views/Mobile.vue'
import Testing from '../views/Testing.vue'
import Archive from '../views/Archive.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    name: 'archive',
    component: Archive
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: Mobile
  },
  {
    path: '/testing',
    name: 'testing',
    component: Testing
  },
  {
    path: '*',
    component: Home
    // Nginx handles routing page refreshes back to index, so app
    // should really serve 404 on paths not found.
    // component: NotFoundComponent
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // Require authentication for every route except login.
  if (to.name !== 'login' && !store.getters.isAuthenticated) {
    next({ name: 'login' })
    // If user tries to log in and is already authenticated, return home.
  } else if (to.name === 'login' && store.getters.isAuthenticated) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router
